import { SegmentSchema } from '@sondermind/segment';

export enum AiConnectSegmentEvents {
  AI_CONNECT_MODULE_VIEWED = 'AI Connect Module Viewed',
  AI_CONNECT_MODULE_START_BUTTON_CLICKED = 'AI Connect Module Start Button Clicked',
  AI_CONNECT_MESSAGE_SENT = 'AI Connect Message Sent',
  AI_CONNECT_EXIT = 'AI Connect Exit'
}

export enum AiConnectProjectType {
  PSL = 'PSL',
  PROVIDER_DIRECTORY = 'provider_directory'
}

export enum AiConnectComponent {
  FIND_MY_FIT = 'find-my-fit',
  CHAT_COMPONENT = 'chat-component'
}

export interface IAiConnectModuleViewedEvent {
  project: AiConnectProjectType;
  component: AiConnectComponent;
  variant: string;
}

export interface IAiConnectModuleStartButtonClickedEvent {
  project: AiConnectProjectType;
  selectedPills: string[];
}

export interface IAiConnectMessageSentEvent {
  project: AiConnectProjectType;
  messageCount: number;
}

export interface IAiConnectExitEvent {
  project: AiConnectProjectType;
}

export interface IAiConnectSegmentSchema extends SegmentSchema {
  [AiConnectSegmentEvents.AI_CONNECT_MODULE_VIEWED]: IAiConnectModuleViewedEvent;
  [AiConnectSegmentEvents.AI_CONNECT_MODULE_START_BUTTON_CLICKED]: IAiConnectModuleStartButtonClickedEvent;
  [AiConnectSegmentEvents.AI_CONNECT_MESSAGE_SENT]: IAiConnectMessageSentEvent;
  [AiConnectSegmentEvents.AI_CONNECT_EXIT]: IAiConnectExitEvent;
}
